import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import EnumeratorField from '@shared/fields/enumerator-field';
import IntegerField from '@shared/fields/integer-field';

function label(name) {
  return i18n(`entities.paymentOption.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.paymentOption.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  type: new EnumeratorField('type', label('type'), [
    { id: 'standard', label: enumeratorLabel('type', 'standard') },
    { id: 'installment', label: enumeratorLabel('type', 'installment') },
    { id: 'suscription', label: enumeratorLabel('type', 'suscription') },
  ],{ "required": true }),
  status: new EnumeratorField('status', label('status'), [
    { id: 'enabled', label: enumeratorLabel('status', 'enabled') },
    { id: 'disabled', label: enumeratorLabel('status', 'disabled') },
  ],{ "required": true }),
  numberOfPayments: new IntegerField('numberOfPayments', label('numberOfPayments'), {
    "required": true
  }),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
};

export class PaymentOptionModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
